export default "__VITE_ASSET__KQ2oyyno__"